import BaseEvent from './BaseEvent.js';

class KickUserEvent extends BaseEvent {
  handle(msg) {
    this.context._api.kickUser(msg.userId);
  }
}

export default KickUserEvent;
